export class Authenticate
{
    public username: string;
    public password: string;
    public selectedLanguage: string;
    public fhirIssuerId: number;
    public fhirProfileId: string;
    public fhirIdToken: string;
}
